import { registerFeedbackForm } from './feedback/FeedbackForm';
import { eventLoader } from '@otto-ec/global-resources/event-loader';

eventLoader.onReady(99, () => {
    registerFeedbackForm();
});
